import { createServerFn } from "@tanstack/react-start";

export const getSitePrices = createServerFn({ method: "GET" }).handler(async () => {
  const { supabaseAdmin } = await import("@/integrations/supabase/client.server");
  const { data, error } = await supabaseAdmin
    .from("site_prices")
    .select(
      "id, label, cash_cents, card_cents, category, duration_minutes, lesson_count, lesson_type_slug, display_order",
    )
    .eq("active", true)
    .order("display_order");
  if (error) throw new Error(error.message);
  return data ?? [];
});
